import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';

interface ITextInput {
  index: number;
  prompt: string;
  isRequired: boolean;
}

const TextInput = ({ index, prompt, isRequired }: ITextInput): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />
      <StyledInput type="text" placeholder="" />
    </QuestionWrapper>
  );
};

export default TextInput;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  font-size: 1em;
  border-radius: 7px;
  border: solid 1px #d2d2d2;
`;
